import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import Message from "./components/Message";
import Loading from "./components/Loading";

const UIContext = createContext();

export function UIProvider({ children }) {
  const [loading, setLoadingVisible] = useState(false);
  const activeLoadingsRef = useRef(0);
  const loadingVisibleRef = useRef(false);
  const [message, setMessage] = useState(null);

  loadingVisibleRef.current = loading;

  const setLoading = useCallback((isLoading) => {
    if (isLoading) {
      activeLoadingsRef.current += 1;
      if (!loadingVisibleRef.current) {
        setLoadingVisible(true);
      }
      return;
    }

    activeLoadingsRef.current = Math.max(0, activeLoadingsRef.current - 1);

    if (activeLoadingsRef.current === 0) {
      setTimeout(() => {
        if (activeLoadingsRef.current === 0) {
          setLoadingVisible(false);
        }
      }, 120);
    }
  }, []);

  const contextValue = useMemo(() => ({
    loading,
    setLoading,
    message,
    setMessage,
  }), [loading, setLoading, message]);

  return (
    <UIContext.Provider value={contextValue}>
      {children}

      {loading && <Loading />}
      {message && <Message {...message} />}
    </UIContext.Provider>
  );
}

export function useUI() {
  return useContext(UIContext);
}
